module.exports = __webpack_public_path__ + "static/media/pn.eb94153e.svg";